import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from "@angular/router";
import {Location} from '@angular/common'

@Component({
  selector: 'app-maintainance-po',
  templateUrl: './maintainance-po.component.html',
  styleUrls: ['./maintainance-po.component.css']
})
export class MaintainancePoComponent implements OnInit {
    selectedTab = 'wip_orders';
	activeTab = "wip_orders";
	tab_search:any;
	data:any;

  constructor(
    private route:ActivatedRoute,
    private _location:Location,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      console.log(params)
      this.route.queryParams.subscribe(params => {
        console.log(params);

        if(params['tab']){
          if(params['tab'] === 'wip_orders'){
            this.activateTab('wip_orders')
          }else{
            this.activateTab('released_orders')
          }
        }else{
          this._location.go('/category/maintenance-po?tab=wip_orders')
        }
      });
    })
  	this.data = 'maintenance'
  }
  //to get active card or tab
  activateTab(tab){
    this.selectedTab = tab;
    switch(tab){
      case "wip_orders":
      this.activeTab = "wip_orders";
      break;
      case "released_orders":
      this.activeTab = "released_orders";
      this.tab_search="released_orders";
      break;
      case "inventory":
      this.activeTab = "inventory";
      this.tab_search="inventory";
      break;
    }
   

  }



}



// WEBPACK FOOTER //
// ./src/app/platform/category/category/maintainance-po/maintainance-po.component.ts